import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    id_curso_escolar:   Yup.string().required('El curso escolar es obligatorio'),
    fecha:              Yup.string().typeError('La fecha es obligatoria').required('La fecha es obligatoria'),
    id_tipo_incidencia: Yup.string().required('La causa es obligatoria'),
    incidencia:         Yup.string().required('La incidencia es obligatoria'),
})